import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all event status records
export const getEventStatus = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching event-status:", error.response?.data || error);
    throw error;
  }
};

// GET a single event status record
export const getEventStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching event-status:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new event status record
export const createEventStatus = async (eventStatusData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-status`, eventStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating event-status:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing event status record
export const updateEventStatus = async (id, eventStatusData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/event-status/${id}`, eventStatusData);
    return response.data;
  } catch (error) {
    console.error("Error updating event-status:", error.response?.data || error);
    throw error;
  }
};

// DELETE an event status record
export const deleteEventStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/event-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting event-status:", error.response?.data || error);
    throw error;
  }
};
